import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "./Logo";

export const LegalLayout = ({ title, updated, children, testId }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="min-h-screen bg-cream text-slate-900" data-testid={testId}>
      <header className="border-b border-navy/10 bg-white">
        <div className="mx-auto flex max-w-4xl items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
          <Link to="/" aria-label="Retour à l'accueil" data-testid="legal-logo-link"><Logo /></Link>
          <Link to="/" className="flex items-center gap-2 text-sm font-semibold text-navy transition-colors hover:text-gold-dark" data-testid="legal-back-link">
            <ArrowLeft size={15} /> Retour au site
          </Link>
        </div>
      </header>
      <main className="mx-auto max-w-4xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
        <p className="font-mono text-xs font-semibold uppercase tracking-[0.22em] text-gold-dark">Informations légales</p>
        <h1 className="mt-4 font-display text-3xl font-bold tracking-tight text-navy sm:text-4xl">{title}</h1>
        <p className="mt-2 text-xs text-slate-500">Dernière mise à jour : {updated}</p>
        <div className="legal-content mt-10 space-y-10">{children}</div>
        <nav className="mt-14 flex flex-wrap gap-4 border-t border-navy/10 pt-6 text-sm font-semibold text-navy">
          <Link to="/mentions-legales" className="hover:text-gold-dark" data-testid="legal-nav-mentions">Mentions légales</Link>
          <Link to="/confidentialite" className="hover:text-gold-dark" data-testid="legal-nav-privacy">Politique de confidentialité</Link>
        </nav>
      </main>
    </div>
  );
};

export const LegalSection = ({ title, children }) => (
  <section>
    <h2 className="font-display text-lg font-bold text-navy md:text-lg">{title}</h2>
    <div className="mt-3 space-y-3 text-sm leading-relaxed text-slate-700 sm:text-base">{children}</div>
  </section>
);

export const ToComplete = ({ children }) => (
  <span className="rounded bg-gold/20 px-1.5 py-0.5 font-mono text-xs font-semibold text-gold-dark" data-testid="legal-to-complete">[À COMPLÉTER : {children}]</span>
);
